import Vue from 'vue';
import { MutationTree } from 'vuex';
import { LoginState } from './state';

const mutations: MutationTree<LoginState> = {
  SET_LOGIN_SELECTED_CHANNEL(state, selectedChannel: 'phone' | 'email') {
    state.selectedChannel = selectedChannel;
  },
  SET_AUTH_TOKEN(state, authToken: string) {
    state.authToken = authToken;
    Vue.$cookies.set('admissions-auth-token', authToken, '7d', '/', '.descomplica.com.br');
  },
  // path e domínio iguais aos da gravação, senão o browser não remove
  REMOVE_AUTH_TOKEN(state) {
    state.authToken = '';
    Vue.$cookies.remove('admissions-auth-token', '/', '.descomplica.com.br');
  },
  SET_LOGIN_SUCCESS(state, success: boolean) {
    state.success = success;
  },
};

export default mutations;
